import React from 'react'
import classnames from 'classnames/bind'

import Link from 'components/shared/Link'
import { Text } from 'components/typo'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const Position = ({
    className,
    title,
    type,
    location,
    label,
    url,
    forwardref
  }) => {
  return (
    <div
      ref={forwardref}
      className={cx(className, css.positionContainer)}
    >
      <div className={css.position}>
        <div className={cx(css.background)} />

        <Link
          className={cx(css.positionLink)}
          to={url}
          href={url}
        >
          <Text className={css.positionTitle}>{title}</Text>
          <div className={css.positionInfo}>
            <p className={css.positionDetails}>
              <span>{type}</span>&nbsp;<span>{location}</span>
            </p>
            <Text tag="span" className={css.positionLabel} theme="royal-blue">
              {label}
            </Text>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Position
